import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import Report from './../../../report/services/report.service';
import Util from './../../../shared/util/util'
import Loader from './../../../shared/components/loader'
import EbnDetails from './../EbnDetails'
import Printd from 'printd'
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
export default {
  name: 'cargo-shipment-bag-summary',
  components: {
    Paginate,
    VueElementLoading,
    Loader,
    EbnDetails
  },
  props: [],
  data() {
    return {
      transcationDetailsForMPSTable:false,
      transcationDetailsForMPS:[],
      auditLog:[],
      showModalBag:false,
      bagShipmentDetails:[],
      showbagShipmentDetailsModal:false,
      bagDetails:[],
      showShipmentDetailsTable:false,
      showBagdetailsTable:false,
      bagNo:'',
      showAWBTrack:false,
      AWBtrackData:[],
      showShipmentTrack:false,
      shipmentTrackData:[],
      paperbagdetails:[],
      showPaperBagTable:false,
      showShipmentTranscationTable:false,
      transcationDetails:[],
      isLoadingSearch: false,
      parentMPS: '',
      ParentMPSError: false,
      ParentMPSErrorMSG: '',
      ParentMPSDetails: [],
      parentAWB: '',
      showParentMPSDetailsTable: false,
      ParentAWBError: false,
      ParentAWBErrorMSG: '',
      hubId: '',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      chargeableWeight:0,
      physicalWeight:0,
      volumetricWeight:0,
      invoicedetailsflag:false,
      invoiceDetails:[],
      mpscount:0,
      awbdetailsflag:false,
      awbdata:[],
      shipmentType:'AWB',
      latlongdetailsflag:false,
      latlongdetails:[],
      showpod:false,
      podimgArr:[],
      fieldImg: "",
      fieldcaption:"POD Image",
      isLoading:false,
      ebndetailsflag:false,
      ebnarr:[],
      printebn:[],
      OcrFieldCaption : "OCR Image"
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment.utc(date).format('DD-MM-YYYY HH:mm:ss');
    },
    BagCategory: function(isparentbag){
      if (isparentbag==true) {
        return "Parent";
      }else if(isparentbag==false){
        return "Child";
      }
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubId = userdetail.hubID[0];
    this.getHubList();
  },
  methods: {
    async getHubList(){
      try{
        this.hublist = []
        let input = {}
        let result = await Report.getHubListdetails(input);
        if(result.data.code == 200){
          this.isLoading = false
          var HubDetails = result.data.hubs.data;
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }else{
          //this.$alert(result.data.message, "", "error");
        }
      } catch(err){
       this.isLoading = false;
       //this.$alert(err, "", "error");
        console.log(err);
      }
    },

    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.setItem('removedtoken5', 'report.view.shipmentQuery.logout')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    showShipmentTranscationDetails(){
      this.showShipmentTranscationTable=true;
    },
    async showInvoiceDetails(awb){
      try{
        this.ebnarr = []
        this.awbdetailsflag = false
        this.invoiceDetails = []
        this.isLoadingSearch = true
        let input = {
          "ShippingID":awb
        }
       let result = await Report.getInvoiceDetails(input)
       this.isLoadingSearch = false
       this.invoicedetailsflag = true
       if(result.data.code == 200){
        this.invoiceDetails = result.data.data.ResultData
        this.invoiceDetails.forEach(el=>{
          if(el.ewaybillsrnumber!=null){
            this.ebnarr.push(el.ewaybillsrnumber)
          }
        })
       }
       else{
        this.invoiceDetails = []
       }
      }catch(err){
        this.isLoadingSearch =false
        console.log(err);
      }
    },
    async showShipmentTranscationDetailsForMPSTrack(ShippingId){
      try{
        this.isLoadingSearch = true;
        let payload2 = {
          ShippingID:ShippingId
        }
        let result = await Report.getCargoShipmentDetails(payload2);
        this.isLoadingSearch = false;
        if (result.data.code == 200) {
          var transcationDetailsForMPS =result.data.data.Transactions
          var hubDetails = [];
          var logData = [];
          for (var i = 0; i < this.hublist.length; i++) {
            hubDetails[this.hublist[i].value] = this.hublist[i].text;
          }
          if (transcationDetailsForMPS.length > 0) {
            transcationDetailsForMPS.forEach(function(item) {
              item["ProcessLocationName"] = '';
              if (item.ProcessLocation && hubDetails[item.ProcessLocation]) {
                item["ProcessLocationName"] = hubDetails[item.ProcessLocation];
              }
              item["CurrentLocationName"] = '';
              if (item.CurrentLocation && hubDetails[item.CurrentLocation]) {
                item["CurrentLocationName"] = hubDetails[item.CurrentLocation];
              }
              logData.push(item);
            });
          }
          this.transcationDetailsForMPS = logData;
          this.invalidTokenModal = false
          this.transcationDetailsForMPSTable=true;
        } else if (result.data.code == 401) {
          this.invalidTokenModal = true
          this.invalidtokenmsg = result.data.message
          this.$alertify.error(result.data.message)
        } else {
          this.invalidTokenModal = false
          this.showParentMPSDetailsTable = true;
          this.ParentMPSDetails = [];
          this.$alertify.error(result.data.message)
        }
      } catch(err){
       this.isLoading = false;
       this.$alert(err, "", "error");
        console.log(err);
      }
    },
    closeModal() {
      this.transcationDetailsForMPSTable=false;
      this.showShipmentTranscationTable = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    closeBagModal() {
      this.showModalBag = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    closeInvoiceDetailsModal() {
      this.invoicedetailsflag = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    getParentMPSDetails() {
      if (!this.parentMPS || !this.parentMPS.trim()) {
        this.ParentMPSError = true;
        this.ParentMPSErrorMSG = 'Enter Shipping ID';
        return false;
      }
      this.ParentMPSError = false;
      this.ParentMPSError = '';
      this.isLoadingSearch = true;
      var parentMPS= this.parentMPS.toUpperCase();
      let MPAstart =new RegExp("^MPA");
      let MPSstart =new RegExp("^MPS");
      let Sstart =new RegExp("^S");
      let Astart =new RegExp("^A");
      this.ParentMPSDetails = [];
      this.showBagdetailsTable=false;
      this.showAWBTrack=false;
      this.showPaperBagTable=false;
      this.showShipmentTrack=false;
      this.paperbagdetails=[];
      this.shipmentTrackData = [];
      this.AWBtrackData=[];
      if (this.shipmentType== 'MPS') {
        this.isLoadingSearch = true;
        Report.getCargoShipmentDetails({
          ShippingID:this.parentMPS.trim()
        })
          .then(result => {
            this.isLoadingSearch = false;
            if (result.data.code == 200) {
              this.showBagdetailsTable = false;
              this.showAWBTrack = false;
              this.showPaperBagTable = false;
              this.showShipmentTrack = false;
              this.invalidTokenModal = false;
              this.showParentMPSDetailsTable = true;
              //this.showParentAWBdetailsTable = false;
              var transcationDetails = result.data.data.Transactions
              var ParentMPSDetails = [];
              ParentMPSDetails.push(result.data.data)
              var hubDetails = [];
              var MPSData = [];
              var logData = [];
              for (var i = 0; i < this.hublist.length; i++) {
                hubDetails[this.hublist[i].value] = this.hublist[i].text;
              }

              if (ParentMPSDetails.length > 0) {
                ParentMPSDetails.forEach(function (item) {
                  item["OriginHubName"] = '';
                  if (item.OriginHubID && hubDetails[item.OriginHubID]) {
                    item["OriginHubName"] = hubDetails[item.OriginHubID];
                  }
                  item["CurrentHubName"] = '';
                  if (item.CurrentHubID && hubDetails[item.CurrentHubID]) {
                    item["CurrentHubName"] = hubDetails[item.CurrentHubID];
                  }
                  item["FinalDestinationName"] = '';
                  if (item.FinalDestinationID && hubDetails[item.FinalDestinationID]) {
                    item["FinalDestinationName"] = hubDetails[item.FinalDestinationID];
                  }
                  MPSData.push(item);
                });
              }
              this.ParentMPSDetails = MPSData;

              if (transcationDetails.length > 0) {
                transcationDetails.forEach(function (item) {
                  item["ProcessLocationName"] = '';
                  if (item.ProcessLocation && hubDetails[item.ProcessLocation]) {
                    item["ProcessLocationName"] = hubDetails[item.ProcessLocation];
                  }
                  item["CurrentLocationName"] = '';
                  if (item.CurrentLocation && hubDetails[item.CurrentLocation]) {
                    item["CurrentLocationName"] = hubDetails[item.CurrentLocation];
                  }
                  logData.push(item);
                });
              }
              this.transcationDetails = logData;
              this.$alertify.success(result.data.message)

            } else {
              this.showBagdetailsTable = false;
              this.showAWBTrack = false;
              this.showPaperBagTable = false;
              this.showShipmentTrack = false;
              this.invalidTokenModal = false
              this.showParentMPSDetailsTable = false;
              this.invalidtokenmsg = result.data.message
              this.$alertify.error(result.data.message)
            }
          }, error => {
            console.error(error)
          })
      }
      else {
        this.ebndetailsflag = false
        let payload2 = {
          ParentAWB:this.parentMPS.trim(),
          ProcessLocation:(this.hubId).toString()
        }
          Report.getPaperBagSummary(payload2)
          .then(result => {
            if (result.data.code == 200) {
              this.showBagdetailsTable=false;

              this.invalidTokenModal = false
              var paperbagdetails=result.data.data;
              var hubDetails = [];
              var paperbagData = [];
              for (var i = 0; i < this.hublist.length; i++) {
                hubDetails[this.hublist[i].value] = this.hublist[i].text;
              }

              if (paperbagdetails.length > 0) {
                paperbagdetails.forEach(function(item) {
                  item["originhubName"] = '';
                  if (item.originhubid && hubDetails[item.originhubid]) {
                    item["originhubName"] = hubDetails[item.originhubid];
                  }
                  item["finaldestinationName"] = '';
                  if (item.finaldestinationid && hubDetails[item.finaldestinationid]) {
                    item["finaldestinationName"] = hubDetails[item.finaldestinationid];
                  }
                  paperbagData.push(item);
                });
              }
              this.paperbagdetails = paperbagData;
              this.showPaperBagTable=true;
              this.showParentMPSDetailsTable = false;
            //  this.showParentAWBdetailsTable = false;
            } else{
              this.invalidTokenModal = false
            }
          }, error => {
            console.error(error)
          })
          let payload = {
            ShippingID : this.parentMPS.trim()
          }
        Report.getCargoParentShipmentDetails(payload)
            .then(result => {
              this.isLoadingSearch = false;
              if (result.data.code == 200) {
                this.showParentMPSDetailsTable = false;
                this.invalidTokenModal = false
                this.showBagdetailsTable=false;
                var shipmentTrackData=[]
                shipmentTrackData.push(result.data.data.ShipmentDetails);
                var hubDetails = [];
                var shipmentData = [];
                for (var i = 0; i < this.hublist.length; i++) {
                  hubDetails[this.hublist[i].value] = this.hublist[i].text;
                }
                if (shipmentTrackData.length > 0) {
                  var vWeight = 0
                  var pWeight = 0
                  var invalidVolWeight = 0
                  var invalidPhyWeight = 0
                  var count = shipmentTrackData[0].length
                  shipmentTrackData[0].forEach((item)=> {
                    if(item.shipmentstatus == 'Invalid' && item.status == 'Invalid'){
                      count --
                      invalidPhyWeight +=Number(item.physicalweight)
                      invalidVolWeight +=Number(item.volumetricweight)
                    }
                    vWeight += Number(item.volumetricweight)
                    pWeight += Number(item.physicalweight)
                    item["originhubName"] = '';
                    if (item.originhubid && hubDetails[item.originhubid]) {
                      item["originhubName"] = hubDetails[item.originhubid];
                    }
                    item["currenthubName"] = '';
                    if (item.currenthubid && hubDetails[item.currenthubid]) {
                      item["currenthubName"] = hubDetails[item.currenthubid];
                    }
                    item["finaldestinationName"] = '';
                    if (item.finaldestinationid && hubDetails[item.finaldestinationid]) {
                      item["finaldestinationName"] = hubDetails[item.finaldestinationid];
                    }
                    if(this.AWBtrackData.length <= 0 && (item.shipmentstatus != 'Invalid' && item.status != 'Invalid')){
                      this.AWBtrackData.push(item);
                    }
                    shipmentData.push(item);
                  });
                }
                pWeight = (pWeight - invalidPhyWeight).toFixed(2)
                vWeight = (vWeight - invalidVolWeight).toFixed(2)
                let cWeight =  Math.max(vWeight,pWeight)
                this.chargeableWeight = cWeight == 0 ? Math.max(invalidPhyWeight,invalidVolWeight) : cWeight
                this.physicalWeight = pWeight == 0 ? invalidPhyWeight : pWeight
                this.volumetricWeight = vWeight == 0 ? invalidVolWeight : vWeight
                this.shipmentTrackData = shipmentData;
                this.mpscount = count == 0 ? this.shipmentTrackData.length : count
                this.AWBtrackData = this.AWBtrackData.length == 0 ? result.data.data.ShipmentDetails[0] : this.AWBtrackData[0]
                if (this.AWBtrackData) {
                  this.AWBtrackData.originhubName = '';
                  if (this.AWBtrackData.originhubid && hubDetails[this.AWBtrackData.originhubid]) {
                    this.AWBtrackData.originhubName = hubDetails[this.AWBtrackData.originhubid];
                  }
                  this.AWBtrackData.currenthubName = '';
                  if (this.AWBtrackData.currenthubid && hubDetails[this.AWBtrackData.currenthubid]) {
                    this.AWBtrackData.currenthubName = hubDetails[this.AWBtrackData.currenthubid];
                  }
                  this.AWBtrackData.finaldestinationName = '';
                  if (this.AWBtrackData.finaldestinationid && hubDetails[this.AWBtrackData.finaldestinationid]) {
                    this.AWBtrackData.finaldestinationName = hubDetails[this.AWBtrackData.finaldestinationid];
                  }
                  this.AWBtrackData.ordertype = this.AWBtrackData.ordertype == 'ToPay'?'FTC':this.AWBtrackData.ordertype
                  this.AWBtrackData.isnewsys = this.AWBtrackData.isnewsys == true ? 'Yes' : 'No'
                  this.AWBtrackData.selfcollect = this.AWBtrackData.isselfcollectbyclient == 1 ? 'Yes' : 'No'
                  this.AWBtrackData.selfdrop = this.AWBtrackData.isshipmentdroptohubbyclient == 1 ? 'Yes' : 'No'
                  let rescheduleddate = this.AWBtrackData.isrescheduledallowed == true? Util.displayDateOnlyFormat(this.AWBtrackData.rescheduleddate):null
                  this.AWBtrackData.rescheduleddate = rescheduleddate == null ? '--' : rescheduleddate
                }
                this.showAWBTrack=true;
                this.showShipmentTrack=true;
                this.$alertify.success(result.data.message)
              } else {
                this.invalidTokenModal = true
                this.invalidtokenmsg = result.data.message
                this.showBagdetailsTable=false;
                this.invalidTokenModal = false
                this.showParentMPSDetailsTable = true;
                this.$alertify.error(result.data.message)
              }
            }, error => {
              console.error(error)
            })
      }
    },
    closebagShipmentDetailsModal(){
      this.showbagShipmentDetailsModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    showModalOnClickBag(bagDetails) {
      this.auditLog = bagDetails.AuditLog
      this.showModalBag = true
    },
    async showShipmentDetails(){
      try{
        this.isLoadingSearchBag = true;
        let result = await Report.getBagShipmentDetailsByBagNumber({bagNo:this.bagNo});
        this.isLoadingSearchBag = false;
        if (result.data.code == 200) {
          this.bagShipmentDetails = result.data.data;
          let totalRows = result.data.data.length;
          this.showbagShipmentDetailsModal = true;

        } else {
          this.$alertify.error(result.data.message);
          this.bagShipmentDetails = [];
        }
      } catch(err){
       this.isLoading = false;
       //this.$alert(err, "", "error");
        console.log(err);
      }
    },
    async getBagDetails(){
      try{
        if (!this.bagNo || !this.bagNo.trim()) {
          this.ParentAWBError = true;
          this.ParentAWBErrorMSG = 'Enter Bag No';
          return false;
        }
        this.showPaperBagTable=false;
        this.showShipmentTrack=false;
        this.showParentMPSDetailsTable = false;
        this.showAWBTrack=false;
      //  this.showParentAWBdetailsTable = false;
        this.bagIdError=false;
        this.bagIDErrorMSG = '';
        this.isLoadingSearch = true;
        this.isLoadingSearchBag = true;
        let result = await Report.getBagDetailsByBagNo({bagno:this.bagNo});
        this.isLoadingSearch = false;
        if (result.data.code == 200) {
          this.showShipmentDetailsTable=false;
          this.showBagdetailsTable=true;
          this.bagDetails = result.data.data;
          //  this.$alertify.success(result.message);

        } else {
          this.showAWBTrack=false;

          this.showShipmentDetailsTable=false;
          this.showBagdetailsTable=true;
          this.$alertify.error(result.data.message);
          this.bagDetails = [];
        }
      } catch(err){
       this.isLoading = false;
       //this.$alert(err, "", "error");
        console.log(err);
      }
    },
    resetForm() {
      this.shipmentType ='AWB',
      this.bagNo='',
      this.showBagdetailsTable=false,
      this.bagDetails='',
      this.transcationDetailsForMPS='',
      this.transcationDetailsForMPSTable=false;
      this.showAWBTrack=false;
      this.AWBtrackData='';
      this.chargeableWeight = 0
      this.physicalWeight = 0
      this.volumetricWeight = 0
      this.showShipmentTrack=false;
      this.shipmentTrackData='';
      this.paperbagdetails='';
      this.showPaperBagTable=false;
      this.ParentMPSDetails = [];
      this.isLoadingSearch = false;
      this.parentMPS = '';
      this.parentAWB = '';
      this.showParentMPSDetailsTable = false;
      this.ParentMPSError = false;
      this.ParentAWBError = false;
      this.ParentMPSErrorMSG = '';
      this.ParentAWBErrorMSG = '';
      this.invoicedetailsflag = false;
      this.mpscount= 0;
      this.$validator.reset();
    },
    showShipmentDetails(awbdetails){
        this.awbdata = []
        this.awbdata = awbdetails
        this.awbdetailsflag = true
        this.podimgArr=[];
        this.latlongdetails=[];
        this.showpod=false
        this.latlongdetailsflag=false
    },
    closeAWBDetailsModal() {
      this.latlongdetailsflag = false
      this.awbdetailsflag = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    async showLatLongDetails(){
      try{ 
        this.isLoading=true;  
        if(this.latlongdetailsflag == true){
          this.latlongdetailsflag = false
        }else{
          this.showpod=false;
          let inputPayload={}
          inputPayload.ParentAWB=this.parentMPS;
           let result = await Report.getLatLongDetailsAgainstParentAwb(inputPayload);
           if (result.data.code == 200) {
            this.isLoading=false;
            this.latlongdetailsflag = true;
             this.latlongdetails =result.data.data;
           } else {
            this.latlongdetailsflag = false;
             this.$alertify.error(result.data.message);
           }
        }
      } catch(err){
       this.isLoading = false;
       this.$alert(err, "", "error");
        console.log(err);
      }
    },
    closeLatLongDetailsModal() {
      this.latlongdetailsflag = false
      this.showpod = false
    },
    async showPODDetails(awb){
      try{
      if(this.showpod == true){
        this.showpod = false
      }else{
        this.isLoading = true
        this.latlongdetailsflag = false
        let payload = {
          "ShippingID":awb
        }
        let result = await Report.getPODDetails(payload)
        this.isLoading = false
        if(result.data.code == 200){
          this.showpod = true
		  let data = result.data.data[0].podImage
		  this.podimgArr =[]
		  if(data){
			for (let i = 0; i < data.length; i++) {
			  let element = data[i];
			  let inputPayload = {
				  filepath : element
			  }
			  let presignUrlData = await TripServices.generatePresignUrl(inputPayload)
			  if (presignUrlData && presignUrlData.data.code == 200) {
				  this.podimgArr.push(presignUrlData.data.data);
			  }
			}
		  }
        }else{
          this.showpod = false
          this.$alertify.error(result.data.message)
        }
      }
      }catch(err){
        this.isLoading = false
        console.log(err)
      }
    },
    closePODImages(){
      this.showpod = false
      this.podimgArr = []
    },
    openImage(image) {
      console.log(image)
      this.fieldImg = image
        this.$nextTick(() => {
          let modal = document.getElementById('myModalImg' + image);
          var img = document.getElementById('imgid' + image);
          var modalImg = document.getElementById("img" + image);
          var captionText = document.getElementById("captionImg" + this.fieldcaption);
          modal.style.display = "block";
          modalImg.src = image;
          captionText.innerHTML = this.fieldcaption;
          this.showpod =false;
          this.awbdetailsflag = false
        })
    },
    openOcrImage(image) {
      this.fieldImg = image
        this.$nextTick(() => {
          let modal = document.getElementById('OcrImg' + image);
          var img = document.getElementById('ocrimgid' + image);
          var modalImg = document.getElementById("ocrimg" + image);
          var captionText = document.getElementById("OcrCaptionImg" + this.OcrFieldCaption);
          modal.style.display = "block";
          modalImg.src = image;
          captionText.innerHTML = this.OcrFieldCaption;
          this.invoicedetailsflag =false
        })
    },
    closePODModal(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
      this.showpod =true;
      this.awbdetailsflag = true
    },
    closeOcrImg(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
      this.invoicedetailsflag = true
    },
    async GetEBNData(ebnpayload){
      let inputPayload = {
        ebn : ebnpayload
      }
      let result = await Report.getEBNDetails(inputPayload)
      return result
    },
    async showEBNDetails(ebn){
      try{
        this.printebn = []
        this.isLoading = true
        this.ebndetailsflag = true
        let ebnpayload = []
        ebnpayload = [ebn]
        let result = await this.GetEBNData(ebnpayload)
        this.isLoading = false
        if(result.data.code == 200){
          result.data.data.forEach(el=>{
            this.printebn.push(el)
          })
        }else{
          this.ebndetailsflag = false
          this.$alertify.error(result.data.message)
        }
      }catch(err){
        this.isLoading = false
        console.log(err)
      }
    },
    closeEbnDetailsModal(){
      this.ebndetailsflag = false
    },
    async PrintAllEBN(){
      try{
        this.ebndetailsflag = false
        this.printebn = []
         let result = await this.GetEBNData(this.ebnarr)
         if(result.data.code == 200){
          result.data.data.forEach(el=>{
            this.printebn.push(el)
          })
          this.PrintEBN()
        // await Promise.all([this.PrintEBN()])
        }else{
          this.$alertify.error(result.data.message)
        }
      }catch(err){
        console.log(err)
      }
    },
    async PrintEBN(){
      try {
        if (this.printebn.length < 1) {
          this.isLoading = false
          return
        }
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
                margin-top: 1rem;
                margin-bottom: 1rem;
                border: 1;
                border-top: 1px solid #000;
            }
           table {
               border-collapse: collapse;
               margin-left:3px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
          this.$nextTick(() => {
            d.print(document.getElementById('printebnData'), cssText);
          })
    } catch (error) {
      this.isLoading=false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/BagShipmentQuery/BagShipmentQuery.component.js